import { BudgetBys } from 'business/constants';
import { translateBlockValue } from 'i18n';
import { BudgetProposalWithResourcesT } from 'routes/BudgetModule/config/types';
import {
    AutocompletAble,
    formatValueForAutocomplete,
} from 'ui/DropdownItems/types';

export const sortBpsOptions = (
    a: AutocompletAble<BudgetProposalWithResourcesT>,
    b: AutocompletAble<BudgetProposalWithResourcesT>,
) =>
    b.value.exercice - a.value.exercice ||
    a.value.name.localeCompare(b.value.name);

export const getFormattedBpsOptions = (
    budgetProposals: BudgetProposalWithResourcesT[],
): AutocompletAble<BudgetProposalWithResourcesT>[] => {
    return budgetProposals.map((budgetProposal) =>
        formatValueForAutocomplete(budgetProposal, false, budgetProposal.name),
    );
};

const getSelectedBudgetProposals = (
    budgetProposals: BudgetProposalWithResourcesT[],
    selectedBudgetProposals: AutocompletAble<BudgetProposalWithResourcesT>[],
): BudgetProposalWithResourcesT[] => {
    const selectedIds = selectedBudgetProposals.map(
        (selected) => selected.value.id,
    );

    return budgetProposals.filter((proposal) =>
        selectedIds.includes(proposal.id),
    );
};

const getAvailableResourcesForSelectedBps = (
    selectedBudgetProposals: BudgetProposalWithResourcesT[],
    mustIgnoreNull: boolean,
): AutocompletAble<string>[] => {
    const uniqueResources = new Map<string, string>();

    selectedBudgetProposals.forEach((proposal) => {
        proposal.resources.forEach((resource) => {
            if (!uniqueResources.has(resource.softwareId)) {
                uniqueResources.set(resource.softwareId, resource.name);
            }
        });
    });
    return Array.from(uniqueResources, ([value, label]) =>
        formatValueForAutocomplete(value, false, label),
    ).filter((item) => !mustIgnoreNull || item.value !== null);
};

export const setAvailableResourcesForBps = (
    budgetProposals: BudgetProposalWithResourcesT[],
    selectedBudgetProposals:
        | AutocompletAble<BudgetProposalWithResourcesT>[]
        | null,
    setAvailableResources: DispatchState<AutocompletAble<string>[]>,
    mustIgnoreNull: boolean = false,
) => {
    if (selectedBudgetProposals === null) return;
    setAvailableResources(
        getAvailableResourcesForSelectedBps(
            getSelectedBudgetProposals(
                budgetProposals,
                selectedBudgetProposals,
            ),
            mustIgnoreNull,
        ),
    );
};

export const getResourceTranslation = (by: BudgetBys) =>
    translateBlockValue(by, true);
export const getResourcesTranslation = (by: BudgetBys) =>
    `${translateBlockValue(by, true)}s`;
